import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

export const BodyItem = React.forwardRef(({ className, children, style }, ref) => {
  return (
    <div
      ref={ref}
      className={classnames("conversation_body_item tw-flex tw-px-2", className)}
      style={style}
    >
      {children}
    </div>
  );
});

BodyItem.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  style: PropTypes.object,
};

BodyItem.displayName = "BodyItem";
